

















































import { Component, Vue, Prop } from "vue-property-decorator";
import * as _ from "lodash";
import { ChangePatientDetail } from "@/request/tongue";
@Component({})
export default class TonguePatientDetailDialog extends Vue {
  @Prop()
  private visible: boolean | undefined;
  @Prop()
  private patient;
  private p: any = {};
  private visibleChange() {
    this.$emit("update:visible", this.visible);
  }
  private get ifVisible() {
    return this.visible ? this.visible : false;
  }
  private set ifVisible(val) {
    this.$emit("update:visible", val);
  }
  /**
   * @description 保存
   */
  private save() {
    if (!this.p["真名"]) {
      this.$message.warning("患者姓名不能为空");
      return;
    }
    const params: any = _.cloneDeep(this.p);
    ChangePatientDetail(this, params).then(() => {
      this.$message.success("修改成功");
      this.$emit("changePatient");
      this.ifVisible = false;
    });
  }
  /**
   * @description 初始化
   */
  private mounted() {
    this.p = _.cloneDeep(this.patient);
  }
}
